import axios, { AxiosInstance } from "axios"

const HTTPClient: AxiosInstance = axios.create({
  withCredentials: true,
  headers: { "Content-Type": "application/json", "Access-Control-Allow-Origin": "http://localhost:3000" },
})

export default HTTPClient
